// Copyright (c) 2025 Audere, All Rights Reserved

export const formatNumber = (num: number | string | null | undefined, decimals = 4): string => {
  if (num == null) return "-";
  const numValue = typeof num === "string" ? parseFloat(num) : num;
  return isNaN(numValue) ? "-" : numValue.toFixed(decimals);
};

export const calcPercent = (value: number, total: number, decimals = 4): string =>
  total ? `${((value / total) * 100).toFixed(decimals)}%` : "0%";
